import React, { Component } from 'react';
import './Tela.css';
import '../CampoDeRuido/A1/A1';

class Tela extends Component{
    render(){
        return(    
        <div className="grandeCampoPreto">
            {this.props.children}
        </div>
        )
    }

}

export default Tela;